import { reverse } from "@reactivated";

import { CSRF_HEADER, fetchJson, getCSRFToken } from "../utils/ajax";

export const submitNPSSurvey = async (
    orderId: number,
    score: number | null,
    comment: string,
): Promise<void> => {
    const csrfToken = await getCSRFToken();
    await fetchJson(reverse("api-nps-survey"), {
        method: "POST",
        keepalive: true,
        headers: {
            "Content-Type": "application/json",
            [CSRF_HEADER]: csrfToken,
        },
        body: JSON.stringify({
            order: orderId,
            score: score,
            comment: comment,
        }),
    });
};
